import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const OnboardingOverview = withLazyFallback(
  () => import('components/shared/OnboardingOverview/OnboardingOverview')
);
const NotFound = withLazyFallback(() => import('components/NotFound'));
const Staff = withLazyFallback(() => import('components/Staff/Staff'));
const AdminBillingProvidersTable = withLazyFallback(
  () => import('components/admin/pages/Practices/Billing/AdminBillingProvidersTable')
);
const FacilityTable = withLazyFallback(
  () => import('components/admin/pages/Practices/Facility/FacilityTable')
);
const AdminFormBuilder = withLazyFallback(
  () => import('components/admin/pages/Practices/FormBuilder/AdminFormBuilder')
);
const AdminPracticesOrganization = withLazyFallback(
  () => import('components/admin/pages/Practices/Organization/Organization')
);
const PracticeOverviewContainer = withLazyFallback(
  () => import('components/admin/pages/Practices/OverviewContainer')
);
const PatientImport = withLazyFallback(
  () => import('components/admin/pages/Practices/PatientImport')
);
const PracticePatients = withLazyFallback(
  () => import('components/admin/pages/Practices/Patients/Patients')
);
const PracticesTable = withLazyFallback(
  () => import('components/admin/pages/Practices/PracticesTable')
);
const Settings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/Settings')
);
const CheckInStepsSettings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/components/CheckInSteps')
);
const ClinicalNotesSettings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/components/ClinicalNotes')
);
const FormsSettings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/components/Forms')
);
const PatientCommunicationSettings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/components/PatientCommunication')
);
const SelfSchedulingSettings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/components/SelfScheduling')
);
const TerminalManagement = withLazyFallback(
  () => import('components/admin/pages/Practices/Terminals/TerminalManagement')
);
const AdminPracticesTransactions = withLazyFallback(
  () => import('components/admin/pages/Practices/Transaction/Transactions')
);
const AdminForms = withLazyFallback(() => import('components/admin/pages/Practices/forms'));
const EditFormBuilderContainer = withLazyFallback(
  () => import('components/admin/pages/Practices/forms/FormEditContainer')
);
const NewFormBuilderContainer = withLazyFallback(
  () => import('components/admin/pages/Practices/forms/new_container')
);
const PracticeProfile = withLazyFallback(() => import('components/admin/pages/Practices/profile'));
const AdminStaff = withLazyFallback(() => import('components/admin/pages/Practices/staff'));
const AdminPracticeDocuments = withLazyFallback(
  () => import('components/admin/pages/Practices/Documents/AdminPracticeDocuments')
);
const KioskSettings = withLazyFallback(
  () => import('components/practice/Settings/components/Kiosks/KioskSettings')
);
const Roles = withLazyFallback(() => import('components/Roles/Roles'));
const OnboardingWizard = withLazyFallback(
  () => import('components/shared/OnboardingWizard/OnboardingWizard')
);

const ADMIN_PRACTICES = [
  {
    path: 'practices',
    element: <PracticesTable />,
    handle: { title: 'Practices' },
    children: [
      {
        path: ':id',
        element: <PracticeProfile />,
        children: [
          { path: '', element: <PracticeOverviewContainer />, handle: { title: 'Overview' } },
          {
            path: 'onboarding',
            element: <OnboardingWizard />,
            children: [
              {
                path: 'overview',
                element: <OnboardingOverview />
              },
              {
                path: ':step_id',
                element: <OnboardingWizard />
              },
              {
                path: ':step_id/:substep_id',
                element: <OnboardingWizard />
              }
            ]
          },
          { path: 'staff', element: <AdminStaff />, handle: { title: 'Staff' } },
          { path: 'patients', element: <PracticePatients />, handle: { title: 'Patients' } },
          {
            path: 'forms',
            element: <AdminForms />,
            handle: { title: 'Forms' },
            children: [
              { path: 'create', element: <NewFormBuilderContainer /> },
              { path: 'edit/:formId', element: <EditFormBuilderContainer /> },
              { path: '*', element: <NotFound /> }
            ]
          },
          {
            path: 'settings',
            element: <Settings />,
            handle: { title: 'Settings' },
            children: [
              { path: 'forms', element: <FormsSettings />, handle: { title: 'Forms' } },
              {
                path: 'patient-communication',
                element: <PatientCommunicationSettings />,
                handle: { title: 'Patient Communication' }
              },
              {
                path: 'clinical-notes',
                element: <ClinicalNotesSettings />,
                handle: { title: 'Clinical Notes' }
              },
              {
                path: 'check-in-steps',
                element: <CheckInStepsSettings />,
                handle: { title: 'Check-In Steps' }
              },
              {
                path: 'self-scheduling-steps',
                element: <SelfSchedulingSettings />,
                handle: { title: 'Self Scheduling' }
              }
            ]
          },
          { path: 'terminals', element: <TerminalManagement />, handle: { title: 'Terminals' } },
          { path: 'roles', element: <Roles />, handle: { title: 'Roles' } },
          {
            path: 'staff-management',
            element: <Staff />,
            handle: { title: 'Staff Management' }
          },
          { path: 'kiosk', element: <KioskSettings />, handle: { title: 'Kiosk' } },
          {
            path: 'patient-import',
            element: <PatientImport />,
            handle: { title: 'Patient Import' }
          },
          {
            path: 'billing',
            element: <AdminBillingProvidersTable />,
            handle: { title: 'Billing' }
          },
          { path: 'facility', element: <FacilityTable />, handle: { title: 'Facility' } },
          {
            path: 'transactions',
            element: <AdminPracticesTransactions />,
            handle: { title: 'Transactions' }
          },
          {
            path: 'organization',
            element: <AdminPracticesOrganization />,
            handle: { title: 'Organization' }
          },
          {
            path: 'form-builder',
            element: <AdminFormBuilder />,
            handle: { title: 'Form Builder' }
          },
          {
            path: 'documents',
            element: <AdminPracticeDocuments />,
            handle: { title: 'Documents' }
          },
          {
            path: 'documents/:pathId',
            element: <AdminPracticeDocuments />,
            handle: { title: 'Documents' }
          },
          { path: '*', element: <NotFound /> }
        ]
      },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default ADMIN_PRACTICES;
